import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Components/PreAuth/Login/login.component';
import { AttendanceComponent } from './Components/attendance/attendance.component';
import { PasswordResetComponent } from './Components/preauth/password-reset/password-reset.component';
import { ScanHistoryComponent } from './components/scan-history/scan-history.component';
import { BarcodeHistoryComponent } from './components/tools/barcode-history/barcode-history.component';
import { GatesComponent } from './components/tools/gates/gates.component';
import { DeleteGateComponent } from './components/tools/gates/delete-gate/delete-gate.component';
import { AddGateComponent } from './components/tools/gates/add-gate/add-gate.component';
import { EditGateComponent } from './components/tools/gates/edit-gate/edit-gate.component';
import { ScannerComponent } from './components/tools/scanner/scanner.component';
import { FeedsComponent } from './components/feeds/feeds.component';
import { AddFeedsComponent } from './Components/feeds/add-feeds/add-feeds.component';
import { UserManagementComponent } from './Components/user-management/user-management.component';
import { EditUserComponent } from './Components/user-management/edit-user/edit-user.component';
import { NewUserComponent } from './Components/user-management/new-user/new-user.component';
import { ShareFeedComponent } from './components/PreAuth/share-feed/share-feed.component';
import { AdminComponent } from './Components/admin/admin.component';
import { PerformanceComponent } from './Components/performance-testing/performance.component';
import { PerformanceDetailComponent } from './Components/performance-testing/performance-detail/performance-detail.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { AuthGuard } from '../services/AuthGuard';

const routes: Routes = [
  
  { 
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',

  },
  { 
    path: 'login', component: LoginComponent, canActivate: [AuthGuard]
  },

  {
    path: 'attendance', component: AttendanceComponent, canActivate: [AuthGuard]
  },
  {
    path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { requiresTicketmasterOnly: true }
  },
  {
    path: 'passwordreset', component: PasswordResetComponent 
  },
  { 
    path: 'scanhistory', component: ScanHistoryComponent , canActivate: [AuthGuard]
  },
  { 
    path: 'tools/barcodehistory', component: BarcodeHistoryComponent,  canActivate: [AuthGuard],  data: {  requiresTicketmaster: true }
  },
  { 
    path: 'tools/gates', component: GatesComponent,  canActivate: [AuthGuard],  data: {  requiresTicketmasterOnly: true }
  },
  {
    path: 'tools/gates/delete', component: DeleteGateComponent , canActivate: [AuthGuard],  data: { requiresTicketmasterOnly: true }
  },
  {
    path: 'tools/gates/add', component: AddGateComponent, canActivate: [AuthGuard],  data: { requiresTicketmasterOnly: true }
  },
  {
    path: 'tools/gates/edit', component: EditGateComponent, canActivate: [AuthGuard], data: {  requiresTicketmasterOnly: true }
  },
  { 
    path: 'tools/scanner', component: ScannerComponent, canActivate: [AuthGuard], data: {  requiresTicketmaster: true }
  },
  { 
    path: 'feeds', component: FeedsComponent, canActivate: [AuthGuard], data: { requiresDeliveryAdmin: true }
  },
  { 
    path: 'feeds/add', component: AddFeedsComponent , canActivate: [AuthGuard], data: { requiresDeliveryAdmin: true }
  },
  { 
    path: 'users/search', component: UserManagementComponent, canActivate: [AuthGuard], data: { requiresVenueAdmin: true }
  },
  { 
    path: 'users/edit', component: EditUserComponent, canActivate: [AuthGuard], data: { requiresVenueAdmin: true }
  },
  { 
    path: 'users/new', component: NewUserComponent, canActivate: [AuthGuard], data: { requiresVenueAdmin: true }
  },
  {
    path: 'share', component: ShareFeedComponent
  },
  {
    path: 'admin', component: AdminComponent, canActivate: [AuthGuard], data: { requiresGlobalAdmin: true }
  },
  {
    path: 'performance', component: PerformanceComponent, canActivate: [AuthGuard], data: { requiresGlobalAdmin: true }
  },
  {
    path: 'performance/:venueID/:timestamp', component: PerformanceDetailComponent, canActivate: [AuthGuard], data: { requiresGlobalAdmin: true }
  },
  { 
    path: '**', 
    redirectTo: '/attendance' 
  },
  { 
    path: 'v2', 
    redirectTo: '/v2/attendance' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
